import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type FilesViewMode = 'list' | 'cards' | 'recent';

type FilesViewState = {
  viewMode: FilesViewMode;
  setViewMode: (viewMode: FilesViewMode) => void;
};

export const useFilesViewStore = create<FilesViewState>()(
  persist(
    (set) => ({
      viewMode: 'list',
      setViewMode: (viewMode) => set({ viewMode }),
    }),
    { name: 'disit-files-view' },
  ),
);
